var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-info"},_vm._l((_vm.infoKeys),function(iK){return _c('h6',[_c('span',{staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm._f("setText")(iK.key,iK.title))+": ")]),(iK.dateFormat)?_c('span',[_vm._v(_vm._s(_vm._f("dateFormat")(_vm.value(iK))))]):_c('span',[_vm._v(_vm._s(_vm.value(iK)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }